/* src/app/app.component.css */
:host {
  display: block;
  min-height: 100vh;
}
/*# sourceMappingURL=app.component.css.map */
